/* eslint-disable */
import React, { useEffect, useState } from 'react';
import { useMatch, useNavigate } from 'react-router-dom';

import Autocomplete from '@mui/material/Autocomplete';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import LinearProgress from '@mui/material/LinearProgress';

import { MdAddCircle, MdArrowBack, MdDelete } from 'react-icons/md';
import InputMask from 'react-input-mask';

import api, { authHeader } from '../../../../../services/API/apiConfig';
import { DialogBox } from '../../../../components/singleComponents/dialogs/DialogBox';
import ToasterBox from '../../../../components/singleComponents/toaster/ToasterBox';

import { Grid2, Radio } from '@mui/material';
import { verifyEmail } from '../../../../../services/auxiliaryFunctions/functions';
import {
  BtnSubmitDivStyled,
  BtnSubmitStyled,
  DeleteButtonStyled,
  FormStyled,
  HeaderModalStyled,
  HeaderTitleStyled,
  InputCategoryStyled,
  InputHeadersStyled,
  NewCategoryInputStyled,
  RadioButtonStyled,
  RadioGroupStyled,
  RootStyled,
  XYStyled,
} from './index.styles';

const states = [
  'AC',
  'AL',
  'AP',
  'AM',
  'BA',
  'CE',
  'DF',
  'ES',
  'GO',
  'MA',
  'MT',
  'MS',
  'MG',
  'PA',
  'PB',
  'PR',
  'PE',
  'PI',
  'RJ',
  'RN',
  'RS',
  'RO',
  'RR',
  'SC',
  'SP',
  'SE',
  'TO',
];

export function FormSuppliers() {
  const navigate = useNavigate();
  const match = useMatch('/new-supplier/:id');
  const id = match ? match.params.id : null;

  const [loading, setLoading] = useState(true);
  const [registeredCategories, setRegisteredCategories] = useState([]);
  const [inputLine, setInputLine] = useState(['']);
  const [supplierHasPayables, setSupplierHasPayables] = useState(false);

  const [documentType, setDocumentType] = useState('CNPJ');
  const [openDialog, setOpenDialog] = useState(false);
  const [openDialogRemoveSupplier, setOpenDialogRemoveSupplier] =
    useState(false);

  const [supplier, setSupplier] = useState({ categories: [] });
  const [categoriesID, setCategoriesID] = useState([]);
  const [categoriesDisplay, setCategoriesDisplay] = useState([]);
  const [invalidCep, setInvalidCep] = useState(false);

  const [successMessage, setSuccessMessage] = useState('');
  const [successSubmit, setSuccessSubmit] = useState(false);

  const [errorMessage, setErrorMessage] = useState('');
  const [errorSubmit, setErrorSubmit] = useState(false);
  const [documentError, setDocumentError] = useState('');
  const [emailError, setEmailError] = useState('');

  function handleGoBack() {
    navigate(-1);
  }

  useEffect(() => {
    if (id) {
      api.get('/payables', {
        headers: authHeader(),
      })
      .then((res) => {
        const { data } = res.data;
        const suppliersIds = data.map(({ supplier }) => supplier.id);
        return suppliersIds.some((supplierId) => supplierId === Number(id));
      })
      .then((hasPayables) => {
        api
          .get(`/suppliers/${id}`, {
            headers: authHeader(),
          })
          .then((res) => {
            const { data } = res.data;
  
            data?.document?.length > 11
              ? handleChangeRadio('CNPJ')
              : handleChangeRadio('CPF');
  
            setSupplierHasPayables(hasPayables);
            setSupplier(data);
            setCategoriesID(data.categories.map((category) => category.id));
            if (!!data.categories.length) {
              setInputLine(data.categories.map((_category) => ''));
            }
          });
      });
    }
  }, []);

  useEffect(() => {
    while (categoriesID.length > inputLine.length) {
      setInputLine([...inputLine, '']);
    }
  }, []);

  useEffect(() => {
    api.get('/categories', { headers: authHeader() }).then((res) => {
      const { data } = res.data;
      setRegisteredCategories(data);
    })
    .then(() => {
      setLoading(false);
    });
  }, []);

  const handleAddNewInputLine = (event) => {
    event.preventDefault();
    setInputLine([...inputLine, '']);

    const newIds = categoriesID;
    newIds[newIds.length] = registeredCategories[0].id;

    const newCategories = [...supplier.categories, registeredCategories[0]];  

    setCategoriesID(newIds);
    setSupplier({ ...supplier, categories: newCategories });
  };

  const onBlurCep = (ev) => {
    const { value } = ev.target;
    const c = value.replace(/[^0-9]/g, '');

    setInvalidCep(false);

    if (c?.length === 8) {
      fetch(`https://viacep.com.br/ws/${c}/json/`)
        .then((response) => response.json())
        // eslint-disable-next-line
        .then((data) => {
          setInvalidCep(data.erro);
          data.erro
            ? setSupplier({ ...supplier, city: '', state: '', address: '' })
            : setSupplier({
                ...supplier,
                zipcode: data.cep,
                city: data.localidade,
                state: data.uf,
                address: data.logradouro,
              });
        });
    } else {
      setInvalidCep(true);
    }
  };

  const handleClickOpenDialog = () => {
    if (supplier.name) {
      setOpenDialog(true);
    }
    navigate('/suppliers');
  };

  const handleOpenDialogRemoveSupplier = () => {
    if (supplierHasPayables) {
      setErrorSubmit(true);
      setErrorMessage('Este fornecedor possui lançamentos associados e não pode ser excluído. Edite os lançamentos para remover a associação antes de excluir este fornecedor.');
      setTimeout(() => {
        setErrorMessage('');
        setErrorSubmit(false);
      }, 6000);
    } else {
      setOpenDialogRemoveSupplier(true);
    }
  };

  const handleCloseDialogRemoveSupplier = () => {
    setOpenDialogRemoveSupplier(false);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
  };

  const handleChangeCategory = (event, value, index) => {
    event.preventDefault();

    const newIds = categoriesID;
    newIds[index] = value?.id;

    let newCategories;
    if (index < supplier.categories.length) {
      newCategories = supplier.categories;
      newCategories[index] = value;
    } else {
      newCategories = [...supplier.categories, value];
    }

    setCategoriesID(newIds);
    setSupplier({ ...supplier, categories: newCategories });
  };

  const handleChangeRadio = (value) => {
    setDocumentType(value);
  };

  const getErrorMessage = (messages) => {
    const [key] = Object.keys(messages);

    switch (key) {
      case 'email':
        return 'O email informado é inválido.';
      case 'state':
        return 'O Estado selecionado é inválido.';
      case 'phone':
        return 'O número de telefone informado é inválido.';
      case 'document':
        return `O documento informado ${messages.document[0]}`;
      default:
        return 'Ocorreu um erro';
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const noCategoryItem = registeredCategories.find(({ name }) => name === 'Sem Categoria Definida');
    const categoriesIds = [...new Set(categoriesID.filter((categoryId) => categoryId !== noCategoryItem.id))];

    const data = {
      supplier: {
        ...supplier,
        address_num: supplier.address_num,
        address_details: supplier.address_details,
        corporate_name: supplier.corporate_name,
        category_ids: categoriesIds,
      },
    };

    Object.keys(data.supplier).forEach((key) => {
      if (data.supplier[key] === '') {
        delete data.supplier[key];
      }
    });

    const options = { headers: authHeader() };
    const apiRequest = id
      ? () => api.patch(`/suppliers/${id}`, data, options)
      : () => api.post('/suppliers', data, options);

    apiRequest().then((res) => {
      if (res.data.status === 0) {
        setSuccessMessage(
          id
            ? 'Fornecedor editado com sucesso.'
            : 'Fornecedor cadastrado com sucesso'
        );
        setSuccessSubmit(true);
        setTimeout(() => {
          handleGoBack();
        }, 2000);
      } else {
        const message = getErrorMessage(res.data.messages);
        setErrorMessage(message);
        setErrorSubmit(true);
      }
    });
  };

  const handleDeleteSupplier = async (supplierId) => {
    await api
      .delete(`/suppliers/${supplierId}`, { headers: authHeader() })
      .then(() => {
        handleCloseDialogRemoveSupplier();
        setSuccessMessage('Fornecedor removido.');
        setSuccessSubmit(true);
        setTimeout(() => {
          navigate('/suppliers');
        }, 1500);
      });
  };

  const handleDocumentBlur = () => {
    const requiredLength = documentType === 'CNPJ' ? 14 : 11;
    const digitsLength = supplier.document.replace(/[^0-9]/g, '').length;

    if (digitsLength !== requiredLength) {
      setDocumentError(
        `O ${documentType} deve conter ${requiredLength} dígitos`
      );
    } else {
      setDocumentError('');
    }
  };

  const handleEmailBlur = () => {
    setEmailError(verifyEmail(supplier.email) ? '' : 'Email inválido');
  };

  if (!registeredCategories || registeredCategories.length === 0) {
    return (
      <div style={{ minHeight: '100vh' }}>
        <LinearProgress sx={{ width: '80%', margin: '40vh auto' }} />
      </div>
    )
  }

  if (loading) {
    return (
      <RootStyled>
        <LinearProgress sx={{ width: '80%', margin: 'auto' }} />
      </RootStyled>
    )
  }

  return (
    <>
      <RootStyled>
        {successSubmit && <ToasterBox message={successMessage} />}
        {errorSubmit && (
          <ToasterBox
            setErrorSubmit={setErrorSubmit}
            message={errorMessage}
            showSeconds={6}
          />
        )}
        <HeaderModalStyled>
          <>
            <Button
              style={{ background: 'none', marginLeft: -20 }}
              onClick={handleClickOpenDialog}
            >
              <MdArrowBack size={25} />
            </Button>
            <HeaderTitleStyled variant="h1">
              {id !== null ? 'Editar fornecedor' : 'Cadastrar fornecedor'}
            </HeaderTitleStyled>
          </>
        </HeaderModalStyled>
        <XYStyled>
          <InputHeadersStyled>Informações da Empresa</InputHeadersStyled>
          {
            id && (
              <DeleteButtonStyled
                onClick={handleOpenDialogRemoveSupplier}
              >
                <MdDelete color="red" />
                <Typography variant="h5">Remover fornecedor</Typography>
              </DeleteButtonStyled>
            )
          }
        </XYStyled>
        <FormStyled onSubmit={handleSubmit}>
          <div id="company-info">
            <RadioGroupStyled
              row
              value={documentType}
              onChange={(e) => handleChangeRadio(e.target.value)}
            >
              <RadioButtonStyled
                value="CNPJ"
                control={<Radio />}
                label="CNPJ"
                labelPlacement="end"
              />
              <RadioButtonStyled
                value="CPF"
                control={<Radio />}
                label="CPF"
                labelPlacement="end"
              />
            </RadioGroupStyled>
            <Grid2 container spacing={2}>
              <Grid2 item size={10}>
                <TextField
                  fullWidth
                  color="secondary"
                  label="Nome da empresa"
                  slotProps={{
                    inputLabel: { shrink: true },
                  }}
                  value={supplier.name}
                  onChange={(e) =>
                    setSupplier({ ...supplier, name: e.target.value })
                  }
                  variant="outlined"
                  required
                />
              </Grid2>
              <Grid2 item size={2}>
                <div>
                  <div>
                    <InputMask
                      mask={
                        documentType === 'CPF'
                          ? '999.999.999-99'
                          : '99.999.999/9999-99'
                      }
                      value={supplier.document}
                      onChange={(e) =>
                        setSupplier({ ...supplier, document: e.target.value })
                      }
                      onBlur={handleDocumentBlur}
                    >
                      {() => (
                        <TextField
                          fullWidth
                          label={documentType}
                          slotProps={{
                            inputLabel: { shrink: true },
                          }}
                          variant="outlined"
                          color="secondary"
                          error={documentError}
                          helperText={documentError}
                        />
                      )}
                    </InputMask>
                  </div>
                </div>
              </Grid2>
              <Grid2 item size={6}>
                <TextField
                  fullWidth
                  label="Razão social"
                  slotProps={{
                    inputLabel: { shrink: true },
                  }}
                  variant="outlined"
                  color="secondary"
                  value={supplier.corporate_name}
                  onChange={(e) =>
                    setSupplier({ ...supplier, corporate_name: e.target.value })
                  }
                />
              </Grid2>
              <Grid2 item size={6}>
                <TextField
                  fullWidth
                  label="Responsável"
                  slotProps={{
                    inputLabel: { shrink: true },
                  }}
                  variant="outlined"
                  color="secondary"
                  value={supplier.responsible}
                  onChange={(e) =>
                    setSupplier({ ...supplier, responsible: e.target.value })
                  }
                />
              </Grid2>
              <Grid2 item size={2}>
                <InputMask
                  mask="99999-999"
                  // eslint-disable-next-line react/jsx-no-bind
                  onBlur={onBlurCep}
                  value={supplier.zipcode}
                  onChange={(e) =>
                    setSupplier({ ...supplier, zipcode: e.target.value })
                  }
                >
                  {() => (
                    <TextField
                      sx={{ width: '100%' }}
                      error={invalidCep}
                      helperText={invalidCep && 'CEP inválido'}
                      label="CEP"
                      slotProps={{
                        inputLabel: { shrink: true },
                      }}
                      variant="outlined"
                      color="secondary"
                    />
                  )}
                </InputMask>
              </Grid2>
              <Grid2 item size={8}>
                <TextField
                  label="Endereço"
                  slotProps={{
                    inputLabel: { shrink: true },
                  }}
                  variant="outlined"
                  color="secondary"
                  style={{ flex: 1, width: '100%' }}
                  value={supplier.address}
                  onChange={(e) =>
                    setSupplier({ ...supplier, address: e.target.value })
                  }
                />
              </Grid2>
              <Grid2 item size={2}>
                <TextField
                  sx={{ width: '100%' }}
                  label="Número"
                  slotProps={{
                    inputLabel: { shrink: true },
                  }}
                  variant="outlined"
                  color="secondary"
                  value={supplier.address_num}
                  onChange={(e) =>
                    setSupplier({ ...supplier, address_num: e.target.value })
                  }
                />
              </Grid2>
              <Grid2 item size={3}>
                <TextField
                  fullWidth
                  label="Cidade"
                  slotProps={{
                    inputLabel: { shrink: true },
                  }}
                  variant="outlined"
                  color="secondary"
                  value={supplier.city}
                  onChange={(e) =>
                    setSupplier({ ...supplier, city: e.target.value })
                  }
                />
              </Grid2>
              <Grid2 item size={1}>
                <Autocomplete
                  options={states}
                  getOptionLabel={(stateLabel) => stateLabel}
                  value={supplier.state}
                  onChange={(_e, value) =>
                    setSupplier({ ...supplier, state: value })
                  }
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Estado"
                      variant="outlined"
                      color="secondary"
                      slotProps={{
                        inputLabel: { shrink: true },
                      }}
                    />
                  )}
                />
              </Grid2>
              <Grid2 item size={8}>
                <TextField
                  fullWidth
                  label="Complemento"
                  slotProps={{
                    inputLabel: { shrink: true },
                  }}
                  variant="outlined"
                  color="secondary"
                  value={supplier.address_details}
                  onChange={(e) =>
                    setSupplier({
                      ...supplier,
                      address_details: e.target.value,
                    })
                  }
                />
              </Grid2>
              <Grid2 item size={8}>
                <TextField
                  fullWidth
                  label="E-mail"
                  slotProps={{
                    inputLabel: { shrink: true },
                  }}
                  variant="outlined"
                  color="secondary"
                  value={supplier.email}
                  onChange={(e) =>
                    setSupplier({ ...supplier, email: e.target.value })
                  }
                  onBlur={handleEmailBlur}
                  error={emailError}
                  helperText={emailError}
                />
              </Grid2>
              <Grid2 item size={2}>
                <InputMask
                  mask="(99) 9999-9999"
                  type="text"
                  value={supplier.phone}
                  onChange={(e) =>
                    setSupplier({ ...supplier, phone: e.target.value })
                  }
                >
                  {() => (
                    <TextField
                      sx={{ width: '100%' }}
                      label="Telefone"
                      slotProps={{
                        inputLabel: { shrink: true },
                      }}
                      variant="outlined"
                      color="secondary"
                    />
                  )}
                </InputMask>
              </Grid2>
              <Grid2 item size={2}>
                <InputMask
                  mask="(99) 99999-9999"
                  type="text"
                  value={supplier.cellphone}
                  onChange={(e) =>
                    setSupplier({ ...supplier, cellphone: e.target.value })
                  }
                >
                  {() => (
                    <TextField
                      sx={{ width: '100%' }}
                      label="Celular"
                      slotProps={{
                        inputLabel: { shrink: true },
                      }}
                      variant="outlined"
                      color="secondary"
                    />
                  )}
                </InputMask>
              </Grid2>
            </Grid2>
          </div>
          <div id="supplier-category">
            <div style={{ display: 'flex', alignItems: 'center', gap: 32 }}>
              <InputHeadersStyled>Categoria do fornecedor</InputHeadersStyled>
            </div>
            <div>
              <Grid2
                container
                rowspacing={1}
                columnspacing={{ xs: 2, sm: 2, md: 2 }}
                style={{ gap: 16 }}
              >
                {!!inputLine.length &&
                  inputLine.map((_line, index) => (
                    <NewCategoryInputStyled item key={`line-${index + 1}`}>
                      <Autocomplete
                        fullWidth
                        options={registeredCategories}
                        getOptionLabel={(category) => category.name}
                        value={
                          index < categoriesID.length
                            ? supplier.categories[index]
                            : registeredCategories.find(({ name }) => name === 'Sem Categoria Definida')
                        }
                        onChange={(e, value) => {
                          handleChangeCategory(e, value, index);
                          setCategoriesDisplay([...categoriesDisplay, value]);
                        }}
                        renderInput={(params) => (
                          <InputCategoryStyled
                            {...params}
                            label="Categoria"
                            variant="outlined"
                            slotProps={{
                              inputLabel: { shrink: true },
                            }}
                          />
                        )}
                      />
                    </NewCategoryInputStyled>
                  ))}
                <IconButton
                  color="primary"
                  onClick={(e) => handleAddNewInputLine(e)}
                  size="large"
                >
                  <MdAddCircle />
                </IconButton>
              </Grid2>
            </div>
          </div>
          <div id="remarks">
            <InputHeadersStyled variant="h4">Observações</InputHeadersStyled>
            <TextField
              fullWidth
              label="Observações"
              slotProps={{
                inputLabel: { shrink: true },
              }}
              variant="outlined"
              color="secondary"
              value={supplier.observation}
              onChange={(e) =>
                setSupplier({ ...supplier, observation: e.target.value })
              }
            />
          </div>
          <BtnSubmitDivStyled>
            <BtnSubmitStyled
              id="new-supplier-btn"
              color="secondary"
              variant="contained"
              type="submit"
            >
              Salvar
            </BtnSubmitStyled>
          </BtnSubmitDivStyled>
        </FormStyled>
      </RootStyled>
      <DialogBox
        title="Cancelar edição de cadastro"
        content="Deseja realmente cancelar a edição? Todas as informações inseridas serão perdidas."
        openDialog={openDialog}
        closeDialog={handleCloseDialog}
        mainAction={() => {
          handleGoBack();
          handleCloseDialog();
        }}
      />
      <DialogBox
        title="Remover fornecedor"
        content="Deseja realmente remover esse fornecedor? Todas as informações inseridas serão perdidas."
        openDialog={openDialogRemoveSupplier}
        closeDialog={handleCloseDialogRemoveSupplier}
        mainAction={() => handleDeleteSupplier(id)}
      />
    </>
  );
}
